var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.block_results_momentarily ? "event-card" : "" },
    [
      _vm.block_results_momentarily
        ? _c("div", [
            _c("p", { staticClass: "text-center q-headline q-pt-md" }, [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(_vm.$t("no_event_completed_please_come_back_later")) +
                  "\n\t\t"
              )
            ])
          ])
        : _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "row justify-center q-mb-sm" },
                [
                  _c("q-btn", {
                    staticClass: "q-pa-sm q-mx-xs",
                    attrs: {
                      color: "primary",
                      icon: "far fa-check-double",
                      label: _vm.$t("print_event_results"),
                      disable: !_vm.permissions.presential_print_results
                    },
                    on: { click: _vm.printEventResults }
                  }),
                  _c("q-btn", {
                    staticClass: "q-pa-sm q-mx-xs",
                    attrs: {
                      color: "primary",
                      icon: "far fa-print",
                      label: _vm.$t("print_attendance_list"),
                      disable: !_vm.permissions.presential_print_users
                    },
                    on: { click: _vm.printAttendanceList }
                  }),
                  _c("q-btn", {
                    staticClass: "q-pa-sm q-mx-xs",
                    attrs: {
                      color: "secondary",
                      icon: "far fa-plus",
                      label: _vm.$t("import_result"),
                      disable: _vm.disableImportParticipant
                    },
                    on: { click: _vm.showImportResult }
                  }),
                  _c("q-btn", {
                    staticClass: "q-pa-sm q-mx-xs",
                    attrs: {
                      color: "secondary",
                      icon: "far fa-plus",
                      label: _vm.$t("add_participants"),
                      disable: _vm.disableFinished || _vm.disableAddParticipant
                    },
                    on: { click: _vm.showAddParticipants }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.participants_selected.length > 0,
                      expression: "participants_selected.length > 0"
                    }
                  ],
                  staticClass: "row justify-center q-my-sm"
                },
                [
                  _c("q-btn", {
                    staticClass: "q-pa-sm",
                    attrs: {
                      color: "negative",
                      icon: "far fa-ban",
                      label: _vm.$t("remove"),
                      disable: _vm.disableFinished
                    },
                    on: { click: _vm.removeParticipants }
                  })
                ],
                1
              ),
              _c(
                "q-tabs",
                {
                  model: {
                    value: _vm.tab_results,
                    callback: function($$v) {
                      _vm.tab_results = $$v
                    },
                    expression: "tab_results"
                  }
                },
                [
                  _vm.event_dates[_vm.tab_results] !== undefined &&
                  _vm.event_dates[_vm.tab_results].has_test === 3 &&
                  !_vm.event_dates[_vm.tab_results].tests
                    ? _c("div", [
                        _c("h6", { staticClass: "q-pa-md text-h6" }, [
                          _vm._v(_vm._s(_vm.$t("still_no_results_for_event")))
                        ])
                      ])
                    : _vm._e(),
                  _vm._l(_vm.event_dates, function(event, index) {
                    return _vm.showEventTab(event)
                      ? _c("q-tab", {
                          key: "t" + index,
                          class: _vm.$v.event_dates.$each[index].$error
                            ? "text-negative"
                            : "",
                          attrs: {
                            slot: "title",
                            name: "" + index,
                            label: _vm.fDate(event.hr_start)
                          },
                          slot: "title"
                        })
                      : _vm._e()
                  }),
                  _vm._l(_vm.event_dates, function(event, index) {
                    return _c(
                      "q-tab-pane",
                      { key: "tp" + index, attrs: { name: "" + index } },
                      [
                        (_vm.event_dates[_vm.tab_results] !== undefined &&
                          _vm.event_dates[_vm.tab_results].has_test === 3 &&
                          _vm.event_dates[_vm.tab_results].tests &&
                          !_vm.event_dates[_vm.tab_results].tests.length) ||
                        _vm.event_dates[index].has_test !== 3
                          ? _c("q-table", {
                              staticClass: "q-mt-xs",
                              attrs: {
                                title: _vm.getTestLabel(
                                  _vm.event_dates[index].has_test
                                ),
                                data: event.participants,
                                columns:
                                  _vm.event_dates[index].has_test === 2
                                    ? _vm.columns_participants
                                    : _vm.columns_participants_small,
                                pagination: _vm.server_pagination,
                                selection: "multiple",
                                selected: _vm.participants_selected,
                                "row-key": "user_id",
                                "no-data-label": _vm.$t("no_data_avaliable"),
                                "no-results-label": _vm.$t("no_results_found"),
                                "loading-label": _vm.$t("loading_data"),
                                "rows-per-page-label": _vm.$t("items_per_page"),
                                "rows-per-page-options": [0],
                                "binary-state-sort": ""
                              },
                              on: {
                                "update:pagination": function($event) {
                                  _vm.server_pagination = $event
                                },
                                "update:selected": function($event) {
                                  _vm.participants_selected = $event
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "top",
                                    fn: function(props) {
                                      return [
                                        _c("q-input", {
                                          attrs: {
                                            "float-label": _vm.$t(
                                              "guests_quantity"
                                            ),
                                            dense: "",
                                            disable: "",
                                            readonly: ""
                                          },
                                          model: {
                                            value: _vm.qtyGuestsInvited,
                                            callback: function($$v) {
                                              _vm.qtyGuestsInvited = $$v
                                            },
                                            expression: "qtyGuestsInvited"
                                          }
                                        }),
                                        _vm.showEventNotFinishedWarning(event)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "q-pt-md col-auto q-ml-auto text-right"
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "uppercase" },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          "" +
                                                            _vm.$t(
                                                              "event_not_finished_please_finish"
                                                            )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _c("q-btn", {
                                                      staticClass: "q-mb-xs",
                                                      attrs: {
                                                        flat: "",
                                                        color: "secondary",
                                                        label: _vm.$t(
                                                          "view_event"
                                                        )
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.goToEvent(
                                                            event
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _c("q-btn", {
                                          staticClass: "q-ml-auto",
                                          attrs: {
                                            flat: "",
                                            color: "secondary",
                                            label: event.is_seleted
                                              ? "Adicionar presença para todos"
                                              : "Remover presença para todos"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.addSelectAll(
                                                event.participants
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    }
                                  },
                                  {
                                    key: "header",
                                    fn: function(props) {
                                      return _c(
                                        "q-tr",
                                        { attrs: { props: props } },
                                        [
                                          _c(
                                            "q-th",
                                            { attrs: { "auto-width": "" } },
                                            [
                                              !_vm.has_uninvited_guest
                                                ? _c("q-checkbox", {
                                                    attrs: {
                                                      "indeterminate-value":
                                                        "some",
                                                      disable:
                                                        _vm.disableFinished
                                                    },
                                                    model: {
                                                      value: props.selected,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props,
                                                          "selected",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "props.selected"
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._l(props.cols, function(col) {
                                            return _c(
                                              "q-th",
                                              {
                                                key: col.name,
                                                attrs: { props: props }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t" +
                                                    _vm._s(_vm.$t(col.label)) +
                                                    "\n\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          })
                                        ],
                                        2
                                      )
                                    }
                                  },
                                  {
                                    key: "body",
                                    fn: function(props) {
                                      return _c(
                                        "q-tr",
                                        {},
                                        [
                                          _c(
                                            "q-td",
                                            { attrs: { "auto-width": "" } },
                                            [
                                              !props.row.is_invited
                                                ? _c("q-checkbox", {
                                                    attrs: {
                                                      color: "primary",
                                                      disable:
                                                        _vm.disableFinished
                                                    },
                                                    model: {
                                                      value: props.selected,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props,
                                                          "selected",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "props.selected"
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "user_id",
                                              attrs: { props: props }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t" +
                                                  _vm._s(props.row.user_id) +
                                                  "\n\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "full_name",
                                              class: props.row
                                                .enrollment_canceled
                                                ? "text-negative"
                                                : "",
                                              attrs: { props: props }
                                            },
                                            [
                                              props.row.enrollment_canceled
                                                ? _c(
                                                    "q-icon",
                                                    {
                                                      staticClass: "q-pr-sm",
                                                      attrs: {
                                                        name:
                                                          "fal fa-exclamation-triangle"
                                                      }
                                                    },
                                                    [
                                                      _c("q-tooltip", [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "enrollment_canceled"
                                                              )
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t"
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t" +
                                                  _vm._s(props.row.full_name) +
                                                  "\n\t\t\t\t\t\t"
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "email",
                                              attrs: { props: props }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t" +
                                                  _vm._s(props.row.email) +
                                                  "\n\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "document",
                                              attrs: { props: props }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t" +
                                                  _vm._s(props.row.document) +
                                                  "\n\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "branches",
                                              attrs: { props: props }
                                            },
                                            [
                                              _c(
                                                "q-btn",
                                                {
                                                  attrs: {
                                                    color: "primary",
                                                    "text-color": "white",
                                                    label: _vm.getQuantityBranches(
                                                      props.row.branches
                                                    ),
                                                    "no-ripple": ""
                                                  }
                                                },
                                                [
                                                  props.row.branches.length > 0
                                                    ? _c("q-tooltip", [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "tooltip q-mb-sm"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "branches"
                                                                  )
                                                                ) +
                                                                ":\n\t\t\t\t\t\t\t\t\t\t"
                                                            ),
                                                            _vm._l(
                                                              props.row
                                                                .branches,
                                                              function(
                                                                branch,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key: index
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                        _vm._s(
                                                                          branch
                                                                        ) +
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                    ),
                                                                    props.row
                                                                      .branches
                                                                      .length -
                                                                      1 >
                                                                    index
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              ",\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "is_present",
                                              attrs: { props: props }
                                            },
                                            [
                                              _c("q-checkbox", {
                                                model: {
                                                  value: props.row.is_present,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      props.row,
                                                      "is_present",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "props.row.is_present"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    props.row.has_test === 2
                                                      ? true
                                                      : false,
                                                  expression:
                                                    "props.row.has_test === 2 ? true : false"
                                                }
                                              ],
                                              key: "score",
                                              attrs: { props: props }
                                            },
                                            [
                                              _c("q-input", {
                                                attrs: {
                                                  error:
                                                    _vm.$v.event_dates.$each[
                                                      index
                                                    ].participants.$each[
                                                      props.row.__index
                                                    ].$error,
                                                  disable:
                                                    _vm.event_dates[index]
                                                      .has_test === 1 ||
                                                    !props.row.is_present ||
                                                    _vm.disableFinished
                                                },
                                                on: {
                                                  input: function($event) {
                                                    _vm.$v.event_dates.$each[
                                                      index
                                                    ].participants.$each[
                                                      props.row.__index
                                                    ].$touch
                                                  }
                                                },
                                                model: {
                                                  value: props.row.score,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      props.row,
                                                      "score",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "props.row.score"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    props.row.has_test === 2
                                                      ? true
                                                      : false,
                                                  expression:
                                                    "props.row.has_test === 2 ? true : false"
                                                }
                                              ],
                                              key: "percent",
                                              attrs: { props: props }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    props.row.percent
                                                      ? props.row.percent.toFixed(
                                                          2
                                                        ) + "%"
                                                      : ""
                                                  ) +
                                                  "\n\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    props.row.has_test === 2
                                                      ? true
                                                      : false,
                                                  expression:
                                                    "props.row.has_test === 2 ? true : false"
                                                }
                                              ],
                                              key: "status",
                                              attrs: { props: props }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.getResult(props.row)
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "actions",
                                              attrs: {
                                                "auto-width": "",
                                                props: props
                                              }
                                            },
                                            [
                                              !props.row.is_invited
                                                ? _c("q-btn", {
                                                    attrs: {
                                                      round: "",
                                                      flat: "",
                                                      icon: "fal fa-trash",
                                                      color: "negative",
                                                      disable:
                                                        _vm.disableFinished
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.removeParticipant(
                                                          props
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          : _c(
                              "q-tabs",
                              {
                                model: {
                                  value: _vm.tab_tests,
                                  callback: function($$v) {
                                    _vm.tab_tests = $$v
                                  },
                                  expression: "tab_tests"
                                }
                              },
                              [
                                _vm._l(
                                  _vm.event_dates[_vm.tab_results].tests,
                                  function(test, index) {
                                    return _c("q-tab", {
                                      key: "t" + index,
                                      attrs: {
                                        slot: "title",
                                        name: "" + index,
                                        label:
                                          _vm.$t("test") + " " + (index + 1)
                                      },
                                      slot: "title"
                                    })
                                  }
                                ),
                                _vm._l(
                                  _vm.event_dates[_vm.tab_results].tests,
                                  function(test, index) {
                                    return _c(
                                      "q-tab-pane",
                                      {
                                        key: "tp" + index,
                                        attrs: { name: "" + index }
                                      },
                                      [
                                        _c("q-table", {
                                          staticClass: "q-mt-xs",
                                          attrs: {
                                            data: event.participants,
                                            columns:
                                              _vm.columns_participants_tests,
                                            pagination: _vm.server_pagination,
                                            selection: "multiple",
                                            selected: _vm.participants_selected,
                                            "row-key": "user_id",
                                            "no-data-label": _vm.$t(
                                              "no_data_avaliable"
                                            ),
                                            "no-results-label": _vm.$t(
                                              "no_results_found"
                                            ),
                                            "loading-label": _vm.$t(
                                              "loading_data"
                                            ),
                                            "rows-per-page-label": _vm.$t(
                                              "items_per_page"
                                            ),
                                            "rows-per-page-options": [0],
                                            "binary-state-sort": ""
                                          },
                                          on: {
                                            "update:pagination": function(
                                              $event
                                            ) {
                                              _vm.server_pagination = $event
                                            },
                                            "update:selected": function(
                                              $event
                                            ) {
                                              _vm.participants_selected = $event
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "top",
                                                fn: function(props) {
                                                  return [
                                                    _c("q-input", {
                                                      attrs: {
                                                        "float-label": _vm.$t(
                                                          "guests_quantity"
                                                        ),
                                                        dense: "",
                                                        disable: "",
                                                        readonly: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.qtyGuestsInvited,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.qtyGuestsInvited = $$v
                                                        },
                                                        expression:
                                                          "qtyGuestsInvited"
                                                      }
                                                    }),
                                                    _vm.showEventNotFinishedWarning(
                                                      event
                                                    )
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "q-pt-md col-auto q-ml-auto text-right"
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "uppercase"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      "" +
                                                                        _vm.$t(
                                                                          "event_not_finished_please_finish"
                                                                        )
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t"
                                                                ),
                                                                _c("q-btn", {
                                                                  staticClass:
                                                                    "q-mb-xs",
                                                                  attrs: {
                                                                    flat: "",
                                                                    color:
                                                                      "secondary",
                                                                    label: _vm.$t(
                                                                      "view_event"
                                                                    )
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.goToEvent(
                                                                        event
                                                                      )
                                                                    }
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c("q-btn", {
                                                      staticClass: "q-ml-auto",
                                                      attrs: {
                                                        flat: "",
                                                        color: "secondary",
                                                        label: event.is_seleted
                                                          ? "Adicionar presença para todos"
                                                          : "Remover presença para todos"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.addSelectAll(
                                                            event.participants
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                }
                                              },
                                              {
                                                key: "header",
                                                fn: function(props) {
                                                  return _c(
                                                    "q-tr",
                                                    { attrs: { props: props } },
                                                    [
                                                      _c(
                                                        "q-th",
                                                        {
                                                          attrs: {
                                                            "auto-width": ""
                                                          }
                                                        },
                                                        [
                                                          _vm.has_uninvited_guest
                                                            ? _c("q-checkbox", {
                                                                attrs: {
                                                                  "indeterminate-value":
                                                                    "some",
                                                                  disable:
                                                                    _vm.disableFinished
                                                                },
                                                                model: {
                                                                  value:
                                                                    props.selected,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props,
                                                                      "selected",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "props.selected"
                                                                }
                                                              })
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      ),
                                                      _vm._l(
                                                        props.cols,
                                                        function(col) {
                                                          return _c(
                                                            "q-th",
                                                            {
                                                              key: col.name,
                                                              attrs: {
                                                                props: props
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      col.label
                                                                    )
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                }
                                              },
                                              {
                                                key: "body",
                                                fn: function(props) {
                                                  return _c(
                                                    "q-tr",
                                                    {},
                                                    [
                                                      _c(
                                                        "q-td",
                                                        {
                                                          attrs: {
                                                            "auto-width": ""
                                                          }
                                                        },
                                                        [
                                                          !props.row.is_invited
                                                            ? _c("q-checkbox", {
                                                                attrs: {
                                                                  color:
                                                                    "primary",
                                                                  disable:
                                                                    _vm.disableFinished
                                                                },
                                                                model: {
                                                                  value:
                                                                    props.selected,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props,
                                                                      "selected",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "props.selected"
                                                                }
                                                              })
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "q-td",
                                                        {
                                                          key: "user_id",
                                                          attrs: {
                                                            props: props
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                props.row
                                                                  .user_id
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "q-td",
                                                        {
                                                          key: "full_name",
                                                          class: props.row
                                                            .enrollment_canceled
                                                            ? "text-negative"
                                                            : "",
                                                          attrs: {
                                                            props: props
                                                          }
                                                        },
                                                        [
                                                          props.row
                                                            .enrollment_canceled
                                                            ? _c(
                                                                "q-icon",
                                                                {
                                                                  staticClass:
                                                                    "q-pr-sm",
                                                                  attrs: {
                                                                    name:
                                                                      "fal fa-exclamation-triangle"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "q-tooltip",
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "enrollment_canceled"
                                                                            )
                                                                          ) +
                                                                          "\n\t\t\t\t\t\t\t\t\t\t"
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                props.row
                                                                  .full_name
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t"
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "q-td",
                                                        {
                                                          key: "email",
                                                          attrs: {
                                                            props: props
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                props.row.email
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "q-td",
                                                        {
                                                          key: "document",
                                                          attrs: {
                                                            props: props
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                props.row
                                                                  .document
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "q-td",
                                                        {
                                                          key: "branches",
                                                          attrs: {
                                                            props: props
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "q-btn",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "primary",
                                                                "text-color":
                                                                  "white",
                                                                label: _vm.getQuantityBranches(
                                                                  props.row
                                                                    .branches
                                                                ),
                                                                "no-ripple": ""
                                                              }
                                                            },
                                                            [
                                                              props.row.branches
                                                                .length > 0
                                                                ? _c(
                                                                    "q-tooltip",
                                                                    [
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "tooltip q-mb-sm"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "branches"
                                                                                )
                                                                              ) +
                                                                              ":\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                          ),
                                                                          _vm._l(
                                                                            props
                                                                              .row
                                                                              .branches,
                                                                            function(
                                                                              branch,
                                                                              index
                                                                            ) {
                                                                              return _c(
                                                                                "span",
                                                                                {
                                                                                  key: index
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                                      _vm._s(
                                                                                        branch
                                                                                      ) +
                                                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                  ),
                                                                                  props
                                                                                    .row
                                                                                    .branches
                                                                                    .length -
                                                                                    1 >
                                                                                  index
                                                                                    ? _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            ",\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e()
                                                                                ]
                                                                              )
                                                                            }
                                                                          )
                                                                        ],
                                                                        2
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "q-td",
                                                        {
                                                          key: "is_present",
                                                          attrs: {
                                                            props: props
                                                          }
                                                        },
                                                        [
                                                          _c("q-checkbox", {
                                                            model: {
                                                              value:
                                                                props.row
                                                                  .is_present,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  props.row,
                                                                  "is_present",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "props.row.is_present"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "q-td",
                                                        {
                                                          key: "score",
                                                          attrs: {
                                                            props: props
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                props.row.tests[
                                                                  _vm.tab_tests
                                                                ].user_result
                                                                  .user_score
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "q-td",
                                                        {
                                                          key: "percent",
                                                          attrs: {
                                                            props: props
                                                          },
                                                          model: {
                                                            value:
                                                              props.row.tests[
                                                                _vm.tab_tests
                                                              ].user_result
                                                                .user_percent,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                props.row.tests[
                                                                  _vm.tab_tests
                                                                ].user_result,
                                                                "user_percent",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "\n\t\t\t\t\t\t\t\t\t\tprops.row.tests[tab_tests].user_result.user_percent\n\t\t\t\t\t\t\t\t\t"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                props.row.tests[
                                                                  _vm.tab_tests
                                                                ].user_result
                                                                  .user_percent ||
                                                                  props.row
                                                                    .tests[
                                                                    _vm
                                                                      .tab_tests
                                                                  ].user_result
                                                                    .user_percent ==
                                                                    0
                                                                  ? props.row.tests[
                                                                      _vm
                                                                        .tab_tests
                                                                    ].user_result.user_percent.toFixed(
                                                                      2
                                                                    ) + "%"
                                                                  : ""
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "q-td",
                                                        {
                                                          key: "status",
                                                          attrs: {
                                                            props: props
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                _vm.getResultOnlineTest(
                                                                  props.row
                                                                    .tests[
                                                                    _vm
                                                                      .tab_tests
                                                                  ].user_result
                                                                    .user_result_status
                                                                )
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "q-td",
                                                        {
                                                          key: "actions",
                                                          attrs: {
                                                            "auto-width": "",
                                                            props: props
                                                          }
                                                        },
                                                        [
                                                          !props.row.is_invited
                                                            ? _c("q-btn", {
                                                                attrs: {
                                                                  round: "",
                                                                  flat: "",
                                                                  icon:
                                                                    "fal fa-trash",
                                                                  color:
                                                                    "negative",
                                                                  disable:
                                                                    _vm.disableFinished
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeParticipant(
                                                                      props
                                                                    )
                                                                  }
                                                                }
                                                              })
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  }
                                )
                              ],
                              2
                            )
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "q-mx-sm row items-start q-gutter-sm" },
                [
                  _c(
                    "q-card",
                    { staticClass: "col-12" },
                    [
                      _c("q-card-title", [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.$t("participating_audience")) +
                            "\n\t\t\t\t"
                        )
                      ]),
                      _c("q-card-separator"),
                      _c("q-card-main", [
                        _c(
                          "div",
                          { staticClass: "row gutter-sm q-pb-sm" },
                          _vm._l(_vm.participants_profile, function(
                            item,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: "ra" + index,
                                staticClass: "col-xs-12 col-sm-4"
                              },
                              [
                                _c("q-input", {
                                  staticClass: "custom-input",
                                  attrs: {
                                    outlined: "",
                                    prefix:
                                      (item.label.length < 30
                                        ? item.label
                                        : item.label.slice(0, 28) + "...") + " "
                                  },
                                  model: {
                                    value: item.qty_participants,
                                    callback: function($$v) {
                                      _vm.$set(item, "qty_participants", $$v)
                                    },
                                    expression: "item.qty_participants"
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _vm.showFinish
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("save")
              },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "positive",
                    label: _vm.$t("finish"),
                    icon: "far fa-check",
                    disable: !_vm.permissions.presential_save_results
                  },
                  on: {
                    click: function($event) {
                      return _vm.finishAppointment()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.showSave && !_vm.block_results_momentarily
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-3",
                class: _vm.getOrder("save")
              },
              [
                _c(
                  "q-btn",
                  {
                    staticClass: "full-width",
                    attrs: {
                      color: "secondary",
                      label: _vm.$t("save_results"),
                      icon: "far fa-save",
                      disable: _vm.disableSaveResults
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveResults()
                      }
                    }
                  },
                  [
                    _vm.permissions.presential_save_results &&
                    _vm.status === 8 &&
                    _vm.disableSaveResults
                      ? _c("q-tooltip", [
                          _c("span", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("training_finalized_tooltip")) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_participants,
            callback: function($$v) {
              _vm.show_participants = $$v
            },
            expression: "show_participants"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_participants = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("participants")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    attrs: {
                      data: _vm.participants_list,
                      columns: _vm.participants_columns,
                      pagination: _vm.participants_pagination,
                      filter: _vm.filter_participants,
                      loading: _vm.loading,
                      selection: "multiple",
                      selected: _vm.participants_selected,
                      "row-key": "id",
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [5, 10, 50, 100],
                      "binary-state-sort": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.participants_pagination = $event
                      },
                      request: _vm.requestParticipants,
                      "update:selected": function($event) {
                        _vm.participants_selected = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "top",
                        fn: function(props) {
                          return [
                            _c("q-search", {
                              attrs: {
                                icon: "far fa-search",
                                placeholder: _vm.$t("search"),
                                "float-label": _vm.$t("search"),
                                debounce: 600
                              },
                              model: {
                                value: _vm.filter_participants,
                                callback: function($$v) {
                                  _vm.filter_participants = $$v
                                },
                                expression: "filter_participants"
                              }
                            }),
                            _c("div", { staticClass: "col" }),
                            _vm.participants_selected.length > 0
                              ? _c("q-btn", {
                                  staticClass: "q-mr-md",
                                  attrs: {
                                    color: "positive",
                                    icon: "far fa-save",
                                    label: _vm.$t("add_participants")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.addParticipants()
                                    }
                                  }
                                })
                              : _vm._e(),
                            _c("q-btn", {
                              attrs: {
                                color: "positive",
                                icon: "far fa-user",
                                label: _vm.$t("new_users")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.createdNewParticipants()
                                }
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-th",
                                { attrs: { "auto-width": "" } },
                                [
                                  _c("q-checkbox", {
                                    attrs: { "indeterminate-value": "some" },
                                    model: {
                                      value: props.selected,
                                      callback: function($$v) {
                                        _vm.$set(props, "selected", $$v)
                                      },
                                      expression: "props.selected"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._l(props.cols, function(col) {
                                return _c(
                                  "q-th",
                                  { key: col.name, attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t(col.label)) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-td",
                                { attrs: { "auto-width": "" } },
                                [
                                  _c("q-checkbox", {
                                    attrs: { color: "primary" },
                                    model: {
                                      value: props.selected,
                                      callback: function($$v) {
                                        _vm.$set(props, "selected", $$v)
                                      },
                                      expression: "props.selected"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "id", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.id) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "full_name", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.full_name) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "email", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.email) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "document", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.document) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "branches", attrs: { props: props } },
                                [
                                  _c(
                                    "q-btn",
                                    {
                                      attrs: {
                                        color: "primary",
                                        "text-color": "white",
                                        label: _vm.getQuantityBranches(
                                          props.row.branches
                                        ),
                                        "no-ripple": ""
                                      }
                                    },
                                    [
                                      props.row.branches.length > 0
                                        ? _c("q-tooltip", [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "tooltip q-mb-sm"
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(_vm.$t("branches")) +
                                                    ":\n\t\t\t\t\t\t\t\t\t\t"
                                                ),
                                                _vm._l(
                                                  props.row.branches,
                                                  function(branch, index) {
                                                    return _c(
                                                      "span",
                                                      { key: index },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(branch) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                        ),
                                                        props.row.branches
                                                          .length -
                                                          1 >
                                                        index
                                                          ? _c("span", [
                                                              _vm._v(
                                                                ",\n\t\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "profile", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.translateProfiles(props.row.profile)
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_create_users,
            callback: function($$v) {
              _vm.show_create_users = $$v
            },
            expression: "show_create_users"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.hideCreateUsers()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("new_users")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("div", { staticClass: "row gutter-sm" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error: _vm.new_user.email_error,
                              "error-label": _vm.new_user.email_error
                                ? "" + _vm.$t("email_not_unique")
                                : ""
                            }
                          },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t("email"),
                                error: _vm.$v.new_user.email.$error
                              },
                              on: {
                                input: _vm.$v.new_user.email.$touch,
                                blur: function($event) {
                                  return _vm.emailUnique()
                                }
                              },
                              model: {
                                value: _vm.new_user.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.new_user, "email", $$v)
                                },
                                expression: "new_user.email"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error: _vm.new_user.document_error,
                              "error-label": _vm.new_user.document_error
                                ? _vm.$t("document_not_unique")
                                : ""
                            }
                          },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t("document"),
                                error: _vm.$v.new_user.document.$error
                              },
                              on: {
                                input: _vm.$v.new_user.document.$touch,
                                blur: function($event) {
                                  return _vm.documentUnique()
                                }
                              },
                              model: {
                                value: _vm.new_user.document,
                                callback: function($$v) {
                                  _vm.$set(_vm.new_user, "document", $$v)
                                },
                                expression: "new_user.document"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-2" },
                      [
                        _c("q-select", {
                          attrs: {
                            "float-label": _vm.$t("profile"),
                            options: _vm.register_profiles,
                            error: _vm.$v.new_user.profile.$error
                          },
                          on: { input: _vm.$v.new_user.profile.$touch },
                          model: {
                            value: _vm.new_user.profile,
                            callback: function($$v) {
                              _vm.$set(_vm.new_user, "profile", $$v)
                            },
                            expression: "new_user.profile"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("full_name"),
                            error: _vm.$v.new_user.full_name.$error
                          },
                          on: { input: _vm.$v.new_user.full_name.$touch },
                          model: {
                            value: _vm.new_user.full_name,
                            callback: function($$v) {
                              _vm.$set(_vm.new_user, "full_name", $$v)
                            },
                            expression: "new_user.full_name"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-1" },
                      [
                        _c("q-btn", {
                          staticClass: "q-mt-md",
                          attrs: {
                            round: "",
                            flat: "",
                            color: "positive",
                            icon: "fal fa-plus"
                          },
                          on: {
                            click: function($event) {
                              return _vm.addNewUser()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._l(_vm.new_users, function(user, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "row gutter-sm" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-3" },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t("email"),
                                disable: ""
                              },
                              model: {
                                value: user.email,
                                callback: function($$v) {
                                  _vm.$set(user, "email", $$v)
                                },
                                expression: "user.email"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-3" },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t(_vm.documentChevrolet),
                                disable: ""
                              },
                              model: {
                                value: user.document,
                                callback: function($$v) {
                                  _vm.$set(user, "document", $$v)
                                },
                                expression: "user.document"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-2" },
                          [
                            _c("q-select", {
                              attrs: {
                                "float-label": _vm.$t("profile"),
                                options: _vm.register_profiles,
                                disable: ""
                              },
                              model: {
                                value: user.profile,
                                callback: function($$v) {
                                  _vm.$set(user, "profile", $$v)
                                },
                                expression: "user.profile"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-3" },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t("full_name"),
                                disable: ""
                              },
                              model: {
                                value: user.full_name,
                                callback: function($$v) {
                                  _vm.$set(user, "full_name", $$v)
                                },
                                expression: "user.full_name"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-1" },
                          [
                            _c("q-btn", {
                              staticClass: "q-mt-md",
                              attrs: {
                                color: "negative",
                                round: "",
                                flat: "",
                                icon: "fal fa-trash"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.removeNewUser(index)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm justify-end q-mt-lg" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-3",
                          class: _vm.getOrder("cancel")
                        },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "tertiary",
                              label: _vm.$t("cancel"),
                              icon: "far fa-chevron-left"
                            },
                            on: {
                              click: function($event) {
                                return _vm.hideCreateUsers()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-3",
                          class: _vm.getOrder("save")
                        },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "secondary",
                              label: _vm.$t("save_new_users"),
                              icon: "far fa-save",
                              disable: _vm.new_users.length === 0 ? true : false
                            },
                            on: {
                              click: function($event) {
                                return _vm.saveNewUsers()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              height: "80vh"
            }
          },
          model: {
            value: _vm.show_modal_create_users,
            callback: function($$v) {
              _vm.show_modal_create_users = $$v
            },
            expression: "show_modal_create_users"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_modal_create_users = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("new_users")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("CreateUsers", {
                    attrs: { id: _vm.presential_event_id },
                    on: { closeRegisterUser: _vm.closeRegisterUser }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_result_import,
            callback: function($$v) {
              _vm.show_result_import = $$v
            },
            expression: "show_result_import"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_result_import = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("import_result")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c(
                    "p",
                    { staticClass: "q-mb-none text-weight-light q-mb-md" },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("guests_import_template_start")) +
                          "\n\t\t\t\t\t"
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "text-weight-medium cursor-pointer",
                          on: {
                            click: function($event) {
                              return _vm.getTemplate()
                            }
                          }
                        },
                        [_vm._v("presential_event_users.xlsx")]
                      ),
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("guests_import_template_end")) +
                          "\n\t\t\t\t"
                      )
                    ]
                  ),
                  _c("uploader", {
                    attrs: {
                      content_type: "xlsx",
                      multiple: false,
                      cropper: false
                    },
                    on: { fileUploaded: _vm.resultImportUpload }
                  }),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm justify-end q-mt-lg" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-3" },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "negative",
                              label: _vm.$t("cancel"),
                              icon: "far fa-times"
                            },
                            on: {
                              click: function($event) {
                                _vm.show_result_import = false
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-3" },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "secondary",
                              label: _vm.$t("save"),
                              icon: "far fa-save"
                            },
                            on: {
                              click: function($event) {
                                return _vm.importResult()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          attrs: { "prevent-close": "" },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("close") },
                    on: {
                      click: function($event) {
                        return _vm.hideFinish()
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "positive", label: _vm.$t("finish") },
                    on: {
                      click: function($event) {
                        return _vm.saveFinish()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_finish,
            callback: function($$v) {
              _vm.show_finish = $$v
            },
            expression: "show_finish"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("finish_appointment")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "do_you_confirm_finishing_this_appointment_this_action_cannot_be_undone"
                )
              )
            )
          ]),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("q-input", {
                attrs: { type: "textarea", placeholder: _vm.$t("observation") },
                model: {
                  value: _vm.finish_observation,
                  callback: function($$v) {
                    _vm.finish_observation = $$v
                  },
                  expression: "finish_observation"
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }